var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { Button, InlineNotification } from '@ui';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ui/molecules/Modal';
import { TextInput, TextArea } from '@ui/molecules/inputs/form/TextInput';
import { DateInput } from '@ui/molecules/inputs/form/DateInput';
import { translate } from '@utils/i18n';
import { createFolder } from '../../services/CustomerFileDropService';
const namespace = 'features.settings.customer_file_drop';
const defaultExpiry = () => {
    const d = new Date();
    d.setDate(d.getDate() + 90);
    return d;
};
const dateToIso = (d) => {
    if (!d)
        return '';
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
function CreateFolderModal({ isOpen, onClose, onCreated }) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [expiresAt, setExpiresAt] = useState(defaultExpiry());
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const handleSubmit = () => __awaiter(this, void 0, void 0, function* () {
        if (!name.trim())
            return;
        setIsSubmitting(true);
        setError(null);
        try {
            yield createFolder(name.trim(), dateToIso(expiresAt), description.trim());
            setName('');
            setDescription('');
            setExpiresAt(defaultExpiry());
            onCreated();
            onClose();
        }
        catch (_a) {
            setError(translate('folder_create_error', { namespace }));
        }
        finally {
            setIsSubmitting(false);
        }
    });
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose, ariaLabel: translate('create_folder', { namespace }) },
        React.createElement(ModalHeader, { title: translate('create_folder', { namespace }), onClose: onClose }),
        React.createElement(ModalBody, null,
            React.createElement("div", { className: "create-folder-modal__body", "data-testid": "create-folder-modal" },
                React.createElement(TextInput, { id: "customer-file-drop-folder-name", label: translate('folder_name_label', { namespace }), value: name, onChange: (e) => setName(e.target.value), placeholder: translate('folder_name_placeholder', { namespace }) }),
                React.createElement(TextArea, { id: "customer-file-drop-folder-description", label: translate('folder_description_label', { namespace }), value: description, onChange: (e) => setDescription(e.target.value), placeholder: translate('folder_description_placeholder', { namespace }), rows: 3 }),
                React.createElement(DateInput, { id: "customer-file-drop-folder-expires", label: translate('expires_at_label', { namespace }), value: expiresAt, onChange: (val) => setExpiresAt(val) }),
                error ? (React.createElement(InlineNotification, { variant: "error", title: error, children: React.createElement("span", null, error) })) : null)),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { variant: "secondary", onClick: onClose, disabled: isSubmitting }, translate('cancel', { namespace: 'features.commons' })),
            React.createElement(Button, { onClick: () => void handleSubmit(), disabled: isSubmitting || !name.trim() }, translate('create_folder_submit', { namespace })))));
}
export default CreateFolderModal;
